<div class="modal-container">
    <mat-icon svgIcon="heroicons_outline:x-circle" matTooltip="Cerrar" class="close-button" mat-dialog-close style="cursor: pointer;"></mat-icon>
    <mat-tab-group class="padding-modal" mat-stretch-tabs="false" [animationDuration]="'0'"
        (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Asignados">
            <mat-dialog-content class="modal-content">
                <div class="relative flex flex-0 flex-col border-b py-4 sm:flex-row sm:items-center sm:justify-between">
                    <div class="text-2xl font-extrabold tracking-tight">{{this.data?.name}}</div>
                    <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                        <button mat-stroked-button color="primary" (click)="onExportButtonPressed(true)" matTooltip="Exportar">
                          <mat-icon class="text-current" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                          <span>Exportar</span>
                        </button>
                        <button mat-icon-button (click)="openModalFrecuency('A')" color="primary">
                            <mat-icon svgIcon="heroicons_solid:map-pin"></mat-icon>
                        </button>
                        <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                            <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                            <input matInput placeholder="Buscar" autocomplete="off" (input)="onSearchChange($event)"/>
                        </mat-form-field>
                        <!-- BACKLOG 2
                        <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Filtro">
                            <mat-icon>more_vert</mat-icon>
                        </button>-->
                        <mat-menu #actionMenu="matMenu">
                            <button mat-menu-item (click)="filterFrecuency('D')">
                                <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
                                <span>Ver Clientes por día</span>
                            </button>
                            <button mat-menu-item (click)="filterFrecuency('F')">
                                <mat-icon svgIcon="heroicons_outline:adjustments-horizontal"></mat-icon>
                                <span>Ordenar Frecuencias</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
                <div class="flex flex-auto overflow-hidden flex-col">
                    <div class="container mt-0 flex-auto flex-col overflow-x-auto">
                        <div class="sticky top-0 z-10 dark:bg-gray-900">
                            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceAssigned" matSort
                                (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Cliente</th>
                                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                        <div class="f-10" *ngIf="getCode(element) as code">
                                            <b style="font-size: 12px;">{{ code }} </b>
                                        </div>
                                        <span class="text-uppercase" 
                                              (mouseenter)="showPopup(element, $event)" 
                                              (mouseleave)="hidePopupWithDelay()">
                                            {{ element?.name }}
                                        </span>
                                        <br *ngIf="element?.commercialName"/>
                                        <span *ngIf="element?.commercialName" class="text-uppercase">
                                            {{ element.commercialName }}
                                        </span>
                                        <br/>
                                        <span style="text-decoration: underline; cursor: pointer;" (click)="openSubRoutesModal(element)">
                                            {{ element?.subRoutes.length }} ruta(s) asignada(s)
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="principalContact">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Información</th>
                                    <td mat-cell *matCellDef="let element" class="f-12 px-6 text-left">
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-4 mr-2" svgIcon="heroicons_outline:user"></mat-icon>{{element?.principalContact?.fullName || "-"}} <br>
                                        </div>
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-4 mr-2" svgIcon="heroicons_outline:phone"></mat-icon>{{element?.principalPhone?.phone || "-"}} <br>
                                        </div>
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-4 mr-2" svgIcon="heroicons_outline:envelope"></mat-icon>{{element?.principalContact?.emails?.[0]?.email || "-"}}
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="principalAddress">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Dirección</th>
                                    <td mat-cell *matCellDef="let element" class="f-12 px-6 text-left">
                                        <div class="flex items-center">
                                            <button mat-icon-button (click)="openModal(element)" style="cursor: pointer;">
                                              <mat-icon class="mr-2" svgIcon="heroicons_solid:map-pin"
                                                [color]="(element?.principalAddress?.geolocationPoint?.[0] === 0 && element?.principalAddress?.geolocationPoint?.[1] === 0) || 
                                                !element?.principalAddress?.geolocationPoint || element?.principalAddress?.geolocationPoint.length == 0 ? 'warn' : 'primary'">
                                              </mat-icon>
                                            </button>
                                            {{element?.principalAddress?.address || "-"}} <br>
                                        </div>
                                        <span *ngIf="element?.principalAddress?.locationTwo?.name">
                                            {{element?.principalAddress?.locationTwo?.name}}
                                            <ng-container *ngIf="element?.principalAddress?.locationThree?.name">, </ng-container>
                                        </span>
                                        
                                        <span *ngIf="element?.principalAddress?.locationThree?.name">
                                            {{element?.principalAddress?.locationThree?.name}}
                                            <ng-container *ngIf="element?.principalAddress?.locationFour?.name">, </ng-container>
                                        </span>
                                        
                                        <span *ngIf="element?.principalAddress?.locationFour?.name">
                                            {{element?.principalAddress?.locationFour?.name}}
                                        </span>                                        
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="geolocationPoint">
                                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                                      ¿Repinear Cliente?
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                      <mat-slide-toggle [disabled]="customerPrincipalAddressHasGeoPoints(element)"
                                        [checked]="element?.principalAddress?.geolocationPointUpdate === true"
                                        (change)="onUpdateGeo($event, element)" color="primary">
                                      </mat-slide-toggle>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="frecuency">
                                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Frecuencia</th>
                                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                        <div style="display: flex; align-items: left;; gap: 8px;">
                                            <button style="margin-top: 6px;" mat-icon-button (click)="openModalCalendar(element)">
                                                <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                                            </button>
                                        <div style="display: flex; flex-direction: column; align-items: left;">
                                            <span style="min-height: 24px;">{{element.bpDaysInAllFrecuencies || '-'}}</span>
                                            <div style="display: flex; justify-content: left; gap: 8px; align-items: baseline;">
                                                <span matTooltip="Frecuencias">D({{element.bpDayFrecuenciesLength}})</span>
                                                <button mat-button color="primary" [disabled]="element.bpCustomFrecuenciesLength===0" (click)="openCustomFrequenciesModal(element)"
                                                    style="padding: 0; min-width: auto; line-height: inherit; margin: 0;"
                                                    matTooltip="Agenda de Eventos">
                                                    A({{element.bpCustomFrecuenciesLength}})
                                                </button>
                                            </div>
                                        </div>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                        <button color="warn" mat-icon-button (click)="onDeleteAssigned(element)">
                                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 dark:bg-gray-900"></tr>                
                                <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b"></tr>
                            </table>
                            <!-- Popup -->
                            <cliente-info-popup *ngIf="selectedClient" 
                                [cliente]="selectedClient" 
                                [position]="popupPosition"
                                (mouseenter)="cancelHidePopup()"
                                (mouseleave)="hidePopupWithDelay()"
                                >
                            </cliente-info-popup>
                            <div *ngIf="this.dataSourceAssigned.data.length === 0" class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">Lo sentimos, no hay registros para mostrar.
                            </div>
                        </div>
                    </div>
                </div>
            </mat-dialog-content>
        </mat-tab>
        <mat-tab label="Sin Asignar">
            <mat-dialog-content class="modal-content">
                <div class="relative flex flex-0 flex-col border-b py-4 sm:flex-row sm:items-center sm:justify-between">
                    <div class="text-2xl font-extrabold tracking-tight">{{this.data?.name}}</div>
                    <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                        <button mat-stroked-button color="primary" (click)="onExportButtonPressed(false)" matTooltip="Exportar">
                            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                            <span>Exportar</span>
                        </button>
                        <button mat-icon-button (click)="openModalFrecuency('U')" color="primary">
                            <mat-icon svgIcon="heroicons_solid:map-pin"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="openModalCalendar(null)" [disabled]="!isGlobalCalendarAvailable">
                            <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                        </button>
                        <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                            <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                            <input matInput placeholder="Buscar" autocomplete="off" (input)="onSearchChangeUnAssigned($event)"/>
                        </mat-form-field>
                        <!-- <button mat-icon-button color="primary" matTooltip="Mostrar filtro">
                            <mat-icon svgIcon="filter_list"></mat-icon>
                        </button> -->
                    </div>
                </div>
                <div class="flex flex-auto overflow-hidden flex-col">
                    <div class="container mt-0 flex-auto flex-col overflow-x-auto">
                        <div class="sticky top-0 z-10 dark:bg-gray-900">
                            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceUnassigned" matSort
                                (matSortChange)="changeSortUnassigned($event)" matSortDisableClear multiTemplateDataRows>
                                <ng-container matColumnDef="det">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <mat-checkbox color="primary" (change)="$event ? masterToggle() : null; onCheckboxChange($event)"
                                            [checked]="selectionUnassigned.hasValue()"
                                            [indeterminate]="selectionUnassigned.hasValue() && !isAllSelected()"
                                            [aria-label]="checkboxLabel()">
                                        </mat-checkbox>
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                            (change)="$event ? selectionUnassigned.toggle(element) : null; onCheckboxChange($event, element)"
                                            [checked]="selectionUnassigned.isSelected(element)"
                                            [aria-label]="checkboxLabel(element)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Cliente</th>
                                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                        <div *ngIf="getCode(element) as code">
                                            <b style="font-size: 12px;">{{ code }} </b> -
                                        </div>
                                        <span class="text-uppercase">{{element?.name}}</span>
                                        <br *ngIf="element?.commercialName"/>
                                        <span *ngIf="element?.commercialName" class="text-uppercase">
                                            {{ element.commercialName }}
                                        </span>
                                        <br/>
                                        {{ element?.subRoutes.length }} ruta(s) asignada(s)
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="principalContact">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Información</th>
                                    <td mat-cell *matCellDef="let element" class="f-12 px-6 text-left">
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-4 mr-2" svgIcon="heroicons_outline:user"></mat-icon>{{element?.principalContact?.fullName || "-"}} <br>
                                        </div>
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-4 mr-2" svgIcon="heroicons_outline:phone"></mat-icon>{{element?.principalPhone?.phone || "-"}} <br>
                                        </div>
                                        <div class="flex items-center">
                                            <mat-icon class="icon-size-4 mr-2" svgIcon="heroicons_outline:envelope"></mat-icon>{{element?.principalContact?.emails?.[0]?.email || "-"}}
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="principalAddress">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Dirección</th>
                                    <td mat-cell *matCellDef="let element" class="f-12 px-6 text-left">
                                         <div class="flex items-center">
                                            <button mat-icon-button (click)="openModal(element)" style="cursor: pointer;">
                                              <mat-icon class="mr-2" svgIcon="heroicons_solid:map-pin"
                                                [color]="(element?.principalAddress?.geolocationPoint?.[0] === 0 && element?.principalAddress?.geolocationPoint?.[1] === 0) || 
                                                !element?.principalAddress?.geolocationPoint || element?.principalAddress?.geolocationPoint.length == 0 ? 'warn' : 'primary'">
                                              </mat-icon>
                                            </button>
                                            {{element?.principalAddress?.address || "-"}} <br>
                                        </div>
                                        <span *ngIf="element?.principalAddress?.locationTwo?.name">
                                            {{element?.principalAddress?.locationTwo?.name}}
                                            <ng-container *ngIf="element?.principalAddress?.locationThree?.name">, </ng-container>
                                        </span>
                                        
                                        <span *ngIf="element?.principalAddress?.locationThree?.name">
                                            {{element?.principalAddress?.locationThree?.name}}
                                            <ng-container *ngIf="element?.principalAddress?.locationFour?.name">, </ng-container>
                                        </span>
                                        
                                        <span *ngIf="element?.principalAddress?.locationFour?.name">
                                            {{element?.principalAddress?.locationFour?.name}}
                                        </span>                                        
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="frecuency">
                                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Frecuencia</th>
                                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                                        <button mat-icon-button (click)="openModalCalendar(element)" [disabled]="isGlobalCalendarAvailable">
                                            <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsUnassigned" class="bg-gray-100 dark:bg-gray-900"></tr>                
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsUnassigned" class="border-b"></tr>
                            </table>
                            <div *ngIf="this.dataSourceUnassigned.data.length === 0" class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">Lo sentimos, no hay registros para mostrar.
                            </div>
                        </div>
                    </div>
                </div>
            </mat-dialog-content>
        </mat-tab>
        <mat-tab label="Frecuencias">
            <mat-dialog-content class="modal-content">
                <app-modal-frecuency [data]="data"></app-modal-frecuency>
            </mat-dialog-content>
        </mat-tab>
        <mat-tab label="Eventos de Visita">
            <mat-dialog-content class="modal-content">
                <app-modal-appointment [data]="data"></app-modal-appointment>
            </mat-dialog-content>
        </mat-tab>
    </mat-tab-group>

    <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
        @if(selectIndex == 0){
        <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
        }
        @if(selectIndex == 1){
        <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItemsUnassigned"
            [pageSize]="pageSizeUnassigned" (page)="changePageUnassigned($event)"></mat-paginator>
        }
    </div>
</div>

<!-- Modales -->
<ng-template #byDayModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Clientes por días</h2>
    <mat-dialog-content class="modal-content">
        <form #daysSelectedForm="ngForm">
            <!-- 
            <p>Visualizar clientes por días que seleccione</p>
            <div class="grid-container">
                <div *ngFor="let day of daysList" >
                    <mat-checkbox style="width: 12px; height: 12px;" color="primary" [(ngModel)]="day.selected"
                    name="selectedDay{{ day.code }}" (change)="onDayFilterSelectionChange(day)">{{ day.day }}</mat-checkbox>
                </div>
            </div> -->
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Visualizar clientes por días que seleccione</mat-label>
                <mat-select [(ngModel)]="selectedFilterDays" name="selectedFilterDays" multiple required>
                    @for (day of daysList; track day) {
                    <mat-option [value]="day.code">
                        {{getNameDay(day.day)}}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="1"
            [disabled]="!daysSelectedForm.valid">Guardar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #frecuencyModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Ordenar Frecuencia</h2>
    <mat-dialog-content class="modal-content">
        <form #frecuencySelectedForm="ngForm">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Frecuencia</mat-label>
                <mat-select [(ngModel)]="selectedFrecuency" name="selectedFrecuency" required>
                    @for (frecuency of listFrecuencies; track frecuency) {
                    <mat-option [value]="frecuency._id">
                        {{ getFrecuencyName(frecuency.days)}}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="1"
            [disabled]="!frecuencySelectedForm.valid">Guardar</button>
    </mat-dialog-actions>
</ng-template>